export default __webpack_public_path__ + "static/media/sparts.7bc75f55.png";